import * as React from "react";

export interface ICardProps {
    url: string;
    // goto: (url: string) => void;
    children?: React.ReactNode;
}

export const Card = (props: ICardProps): React.ReactElement<ICardProps> => {
    return (
        <div className={`wpo ui clickable card`} onClick={(event: React.MouseEvent<HTMLElement>) => window.open(props.url, '_blank')}>
            {
                props.children
            }
        </div>
    )
};









